<template>
	<div v-loading.fullScreen="loading">
		<div v-if="!loading" class="profile-root">
			<div class="profile-sidebar">
				<profile-sidebar />
			</div>
			<div class="profile-content">
				<profile-subscription-paused-bar :is-show="isShowSubscriptionPausedBar" />
				<div class="profile-manager-wrap">
					<profile-manager />
				</div>
				<div class="profile-view">
					<nuxt :keep-alive-props="{ exclude: ['MyPixellot', 'TeamId'] }" keep-alive />
				</div>
			</div>
		</div>
		<div>
			<chat />
			<modal />
			<toaster />
			<analytics-popup />
		</div>
		<pixellot-footer v-if="!loading" />
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import PixellotFooter from '~/components/PixellotFooter'
import { Modal, Toaster } from '~/components/managers'
import { ProfileSidebar, ProfileManager } from '~/components/particles'
import ProfileSubscriptionPausedBar from '~/components/ProfileSubscriptionPausedBar'
import Chat from '~/components/interface/Chat'
import AnalyticsPopup from '~/components/AnalyticsPopup'

export default {
	name: 'Profile',
	components: {
		Chat,
		Modal,
		Toaster,
		PixellotFooter,
		ProfileSidebar,
		ProfileManager,
		ProfileSubscriptionPausedBar,
		AnalyticsPopup
	},
	data: () => ({ loading: true }),
	computed: {
		...mapGetters({ plans: 'plans/plans', activePlan: 'plans/active' }),
		isShowSubscriptionPausedBar () {
			return this.plans.length === 1 && Boolean(this.activePlan?.software?.isPaused) && this.$route.name !== 'profile-manage-plans'
		}
	},
	created () {
		this.loading = true

		this.fetchPlans()
			.then(this.fetchProducts)
			.then(this.fetchSportTypes)
			.catch(this.onError)
			.finally(() => {
				this.loading = false
			})
	},
	methods: {
		...mapActions({
			fetchProducts: 'products/fetchProducts',
			fetchPlans: 'plans/fetchPlans',
			fetchSportTypes: 'user/fetchSportTypes'
		}),

		onError (error) {
			this.loading = false

			const message = error && error.message
			const loginErrorCallback = () => {
				this.$toast.error(message || this.$tc('errors.fetchError'))
			}

			return this.$router.push({ name: 'login', params: { logout: true, callback: loginErrorCallback } })
		}
	}
}
</script>
